import React, { useEffect, useState } from 'react';
import Image from '../Image';
import Button from '../Button';
import { useModal } from '../../context/ModalContext';

import { useNavigate } from 'react-router-dom';

   const kits = [
        {
            id: 1,
            version: 'ESSENCIAL',
            image: 'kit-essencial-modal.png',
            subtitle: 'O básico que não pode faltar',
            imageRodape: 'banner-modal-rodape-essencial.png',
            textBanner: '<span class="d-lg-block">Para quem busca uma base nutricional segura,</span>  eficaz e financeiramente acessível.',
            content: 'Entrega o conjunto de nutrientes essenciais para restaurar e sustentar as bases fisiológicas da saúde. Cada nutriente é escolhido com base nas suas respostas, para entregar o que seu corpo realmente precisa. Proteínas, aminoácidos funcionais, ácidos graxos essenciais, vitaminas, minerais e ativos de ação clínica — todos em doses efetivas e bioativas.',
            details: [
                {
                  title: 'Proteína de Colágeno (10g) + Whey isolado (5g)',
                  description: 'Proteína leve, de altíssima absorção, que nutre tecidos estruturais, promove saciedade e favorece a longevidade celular.',
                },
                {
                  title: 'Creatina monohidratada (5g)',
                  description: 'Aumenta força, energia muscular, memória de trabalho, desempenho cognitivo e regeneração celular.',
                },
                {
                  title: 'Glutamina + Taurina',
                  description: 'Proteção da mucosa intestinal, suporte imunológico, equilíbrio neuroquímico, relaxamento noturno e ação antioxidante intracelular.',
                },
                {
                  title: "VITAMINAS E MINERAIS EM DOSES ÓTIMAS E FORMAS BIOATIVAS",
                  description: "",
                  subItems: [
                    {
                      title: "Vitamina D3 + K2 MK7",
                      subtitle: 'Sinergia óssea e imunológica'
                    },
                    {
                      title: "Magnésio bisglicinato",
                      subtitle: 'Neuromodulação e produção de ATP'
                    },
                    {
                      title: "Vitaminas B6/B9/B12 Metiladas",
                      subtitle: ''
                    },
                    {
                      title: "Silício orgânico",
                      subtitle: ''
                    },
                    {
                      title: "Selênio",
                      subtitle: ''
                    },
                    {
                      title: "Zinco",
                      subtitle: ''
                    },
                    {
                      title: "Vitamina C",
                      subtitle: ''
                    },
                    {
                      title: "Selênio",
                      subtitle: ''
                    },
                    {
                      title: "Entre outros"
                    }
                  ]
              },
              {
                title: "COMPLEXO DE BIOATIVOS CLÍNICOS",
                description: "",
                subItems: [
                    {
                      title: "Coenzima Q10",
                      subtitle: 'Ativa a geração mitocondrial de energia e protege contra o estresse oxidativo celular'
                    },
                    {
                      title: "Curcumina padronizada",
                      subtitle: 'Modula a inflamação sistêmica e combate o envelhecimento silencioso'
                    },
                    {
                      title: "Própolis verde",
                      subtitle: 'Fortalece a imunidade inata e regula a microbiota com ação antimicrobiana natural'
                    },
                    {
                      title: "NAC + MSM",
                      subtitle: 'Sinergia para desintoxicação hepática, proteção pulmonar e conforto articular'
                    },
                    {
                      title: "Inositol e L-Theanina",
                      subtitle: 'Reguladores neuroadaptativos que restauram o eixo do estresse, melhoram o sono e equilibram o humor'
                    },
                    {
                      title: "Berberina HCL",
                      subtitle: 'Ativa vias metabólicas de sensibilidade à insulina, regula a glicemia e apoia o emagrecimento clínico'
                    }
                  ]
              }
            ]
        },
        {
            id: 2,
            version: 'AVANÇADA',
            image: 'kit-avancado-modal.png',
            subtitle: 'Potência clínica aprimorada, para camada extra de performance.',
            imageRodape: 'banner-modal-rodape-avancado.png',
            textBanner: '<span class="d-lg-block">Para quem deseja resultados mais rápidos,</span><span class="d-lg-block"> profundos e completos — com foco em energia,</span> equilíbrio emocional, regeneração e longevidade.',
            content: 'Tudo o que seria ofertado através do plano Essencial, enriquecido por adições/upgrades relevantes em forma molecular, tecnologia de liberação, sinergia entre ativos e potência clínica.',
            details: [
                {
                  title: 'CreaPure',
                  description: 'Creatina patenteada com pureza máxima e estabilidade superior.',
                },
                {
                  title: 'Lipofer',
                  description: 'Ferro lipossomal de altíssima absorção, sem efeitos gastrointestinais adversos.',
                },
                {
                  title: 'CavaCurmin + CavaQ10',
                  description: 'Curcumina e Coenzima Q10 com ciclodextrina, até 1.800% mais biodisponíveis.',
                },
                {
                  title: 'Fisetina + Telogen',
                  description: 'Ação senolítica e proteção dos telômeros para redução do envelhecimento celular.',
                },
                {
                  title: 'PQQ + Alfa-GPC + NAC',
                  description: 'Estímulo à biogênese mitocondrial, regeneração neuronal, suporte cognitivo e desintoxicação profunda. Potencializa clareza mental, energia celular e resiliência neuroquímica.',
                },
                {
                  title: 'Própolis Mais, wellmune e GABA',
                  description: 'Indução natural do sono profundo, redução da excitabilidade neural e ação antioxidante de alta biodisponibilidade. Favorece relaxamento restaurador e imunorregulação noturna.',
                },
                {
                  title: 'Bioxina, Trans-Resveratrol, Cromo GTF e Colina (Alfa-GPC)',
                  description: 'Potencialização antioxidante avançada, otimização do metabolismo da glicose, suporte à memória e à integridade estrutural cerebral. Atua em vias de reparo celular e longevidade metabólica.',
                },
                {
                  title: 'UC-II (Colágeno tipo 2 não desnaturado)',
                  description: 'Atua como sinalizador imunológico de regeneração articular. Reduz dor, melhora mobilidade e favorece a saúde das articulações com respaldo clínico robusto.',
                }
            ]
        },
        {
            id: 3,
            version: 'PREMIUM',
            image: 'kit-premium-modal.png',
            subtitle: 'O estado da arte da suplementação',
            imageRodape: 'banner-modal-rodape-premium.png',
            textBanner: '<span class="d-lg-block">Para quem busca o ápice do que a suplementação </span><span class="d-lg-block"> personalizada pode oferecer: os ativos mais eficazes,</span><span class="d-lg-block"> as tecnologias mais avançadas e as combinações</span> que geram os melhores resultados.',
            content: 'Neste nível, sua fórmula integra os ingredientes mais efetivos e tecnologicamente avançados da nutrição funcional contemporânea. Um novo paradigma em longevidade funcional, regeneração mitocondrial, desempenho metabólico de elite e estética elevada ao estado da arte. No plano PREMIUM, é possível incorporar os ativos mais nobres já estudados, e por isso,  sua fórmula é projetada para regenerar, proteger e expandir seu potencial fisiológico — enquanto desacelera, de forma mensurável, os marcadores do envelhecimento. O ápice da performance física e mental.',
            details: [
                {
                  title: 'Urolitina A',
                  description: 'Estimula a mitofagia — processo de renovação das mitocôndrias — promovendo energia celular sustentada, maior vitalidade e desaceleração do envelhecimento.',
                },
                {
                  title: 'Niagen + Riagev',
                  description: 'Três rotas complementares de estímulo à produção de NAD⁺, molécula-chave para longevidade, reparo celular e função mitocondrial plena.',
                },
                {
                  title: 'CreaVitalis',
                  description: 'A forma mais pura e patenteada de creatina. Eleva desempenho físico, cognição, síntese de ATP e regeneração neuromuscular.',
                },
                {
                  title: 'Chronic',
                  description: 'Extrato padronizado de urucum com ação anti-inflamatória, antioxidante e regeneradora sobre músculos, articulações e tecidos de sustentação.',
                },
                {
                  title: 'UC-II e Mesoporosil',
                  description: 'Tríplice aliança para suporte estrutural completo:',
                  subItems: [
                    {
                      title: "UC-II",
                      subtitle: 'Atua como sinalizador imunológico para regeneração articular, com redução de inflamação e dor.'
                    },
                    {
                      title: "Mesoporosil",
                      subtitle: 'Entrega silício estabilizado com ação direta sobre pele, cabelos e matriz extracelular.'
                    }
                  ]
                },
                {
                  title: 'Fosfatidilserina + Alfa-GPC',
                  description: 'Ativos neuroestruturais que favorecem foco, memória, aprendizado e proteção contra o declínio cognitivo relacionado à idade.',
                },
                {
                  title: 'PQQ, NAC e Bioxina',
                  description: 'Combinação estratégica que promove biogênese mitocondrial, suporte à detoxificação celular profunda e potente efeito antioxidante — otimizando energia, clareza mental e resiliência metabólica.',
                },
                {
                  title: 'Fisetina + Telogen',
                  description: 'Ação senolítica e proteção dos telômeros — removendo células envelhecidas e retardando o encurtamento genético associado ao envelhecimento celular.',
                },
                {
                  title: 'Querceteam (Phytossome) + Trans-Resveratrol',
                  description: 'Antioxidantes de alta biodisponibilidade que atuam na ativação de vias de longevidade, como as sirtuínas, além de promoverem proteção vascular e neutralização de radicais livres.',
                },
                {
                  title: 'Fosfatidilserina + Alfa-GPC',
                  description: 'Ativos neuroestruturais que favorecem foco, memória, aprendizado e proteção contra o declínio cognitivo relacionado à idade.',
                },
                {
                  title: 'Inositol e L-Theanina',
                  description: 'Regulação do eixo HPA, redução do cortisol, relaxamento neurológico e suporte cognitivo. Essa tríade atua de forma sinérgica na modulação do estresse, qualidade do sono e clareza mental.',
                },
                {
                  title: 'Cromo GTF',
                  description: 'Cofator essencial no metabolismo da glicose, com efeito direto na sensibilidade à insulina, controle do apetite e composição corporal.',
                },
                {
                  title: 'Própolis Mais',
                  description: 'Blend padronizado de três tipos de própolis (verde, vermelho e marrom) com ação imunomoduladora, antioxidante e antimicrobiana.',
                },
                {
                  title: 'Wellmune',
                  description: 'Defesa imunológica de elite. Wellmune é a beta-glucana mais estudada do mundo — modula o sistema imune inato sem hiperestimulação. Lactoferrina, presente no colostro, protege mucosas e otimiza a resposta imunológica e intestinal.',
                },
                {
                  title: 'Cerasomides + Ácido Hialurônico',
                  description: 'Rejuvenescimento estético in-out: hidratam profundamente, reparam a barreira cutânea e melhoram elasticidade e firmeza da pele desde as camadas internas.',
                },
                {
                  title: 'Herbatonin e Relax PLX',
                  description: 'Dupla ação sobre o sono: Herbatonin entrega melatonina vegetal em doses fisiológicas e seguras e Relax PLX facilita a indução do relaxamento.',
                },
                {
                  title: 'Fosfolipídeos de Caviar',
                  description: 'Ingrediente raro e precioso, com ação regeneradora sobre membranas celulares. Promove longevidade estética, integridade mitocondrial e nutrição profunda em nível celular.',
                }
            ]
        },
    ];

const ModalKitContentFarma = () => {
  const navigate = useNavigate();
  const { closeModal, modalData } = useModal();

  if (!modalData) return null;

  const version = modalData.version;

  const kit = kits.find((k) => k.version.toLowerCase() === version?.toLowerCase());

  const handleNavigate = (url) => {
    closeModal();
    navigate(url);
  };

  return (
    <div id="ModalKitContentFarma" className="ModalKitContentFarma carousel slide" data-bs-ride="false">
        <div className="carousel-item active inner">
            <div className="container-fluid">
            <div className="row justify-content-center text-center">
              <div className="col">
                <h2 className="big">MY FORMULA <br/><strong>{kit.version}</strong></h2>
              </div>
            </div>
            <div className="row justify-content-center text-center">
              <div className="col" style={{ maxWidth: "630px" }}>
                <h3 className="mb-4 text-center">{kit.subtitle}</h3>
              </div>
            </div>

            <div className="row justify-content-center text-center">
              <div className="col">
                <Image image={kit.image} title={kit.version} className="img-fluid" />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-11 col-lg-10 text-box">
                <p>{kit.content}</p>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-11 col-lg-10 title-box">
                <h3>Destaques clínicos | <b>{kit.version}</b></h3>
                <hr class="line" />
                <h4>Cerca de {kit.actives} ativos</h4>
              </div>
            </div>

            <div className="row justify-content-center my-5" style={{ maxWidth: '1010px' }}>
              <div className="col-11 col-lg-10">
                {kit.details.map((detail, index) => (
                  <div className="box-text d-flex align-items-start gap-2" key={index}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6DAE68" viewBox="0 0 16 16">
                      <path d="M12.0001 1.07191C13.2068 1.7686 14.2105 2.76833 14.912 3.97215C15.6135 5.17597 15.9885 6.54213 15.9997 7.93538C16.011 9.32864 15.6582 10.7007 14.9762 11.9157C14.2942 13.1307 13.3068 14.1465 12.1115 14.8626C10.9163 15.5787 9.55481 15.9702 8.16178 15.9984C6.76875 16.0266 5.39251 15.6904 4.16929 15.0233C2.94608 14.3562 1.91832 13.3811 1.18775 12.1947C0.457175 11.0083 0.049128 9.65168 0.00400014 8.25911L0 7.99991L0.00400014 7.74071C0.0488032 6.3591 0.450844 5.01268 1.17093 3.83271C1.89101 2.65273 2.90456 1.67948 4.11276 1.00782C5.32097 0.336164 6.6826 -0.0109686 8.0649 0.000264197C9.44721 0.011497 10.803 0.380712 12.0001 1.07191ZM10.9657 5.83431C10.828 5.69657 10.6447 5.61383 10.4503 5.6016C10.2559 5.58938 10.0636 5.64851 9.90972 5.76791L9.83452 5.83431L7.20009 8.46791L6.16568 7.43431L6.09048 7.36791C5.93654 7.2486 5.74437 7.18953 5.54999 7.20179C5.35562 7.21406 5.17239 7.29681 5.03467 7.43452C4.89695 7.57224 4.81421 7.75546 4.80194 7.94984C4.78968 8.14421 4.84874 8.33638 4.96806 8.49031L5.03446 8.56551L6.63448 10.1655L6.70968 10.2319C6.84998 10.3408 7.02251 10.3998 7.20009 10.3998C7.37767 10.3998 7.55019 10.3408 7.69049 10.2319L7.7657 10.1655L10.9657 6.96551L11.0321 6.89031C11.1515 6.73639 11.2107 6.54419 11.1984 6.34977C11.1862 6.15535 11.1035 5.97207 10.9657 5.83431Z" />
                    </svg>
                    <div className="box-content">
                      <h4 className='mb-0'>{detail.title}</h4>
                      <p className="mb-3" dangerouslySetInnerHTML={{ __html: detail.description }} />
                      {detail.subItems && (
                        <div className='box-subtitle ms-lg-3'>
                          {detail.subItems.map((sub, subIndex) => (
                            <div key={subIndex} className="mb-2">
                              <div className="d-flex align-items-start">
                                <span className="bullet me-2">•</span>
                                {sub.title && <h4 className="m-0">{sub.title}</h4>}
                              </div>
                              {sub.subtitle && <p className="mb-1 ms-4">{sub.subtitle}</p>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="row justify-content-center text-center my-5 my-lg-0">
              <div className="col-10 col-lg-auto">
                <h3 className='text-footer'><b>Puríssima. </b> <br/>Nutrição de precisão - para sua evolução.</h3>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default ModalKitContentFarma;